module.exports = __webpack_public_path__ + "img/default-speaker.2ba96a0c.jpg";